<template>
  <v-row class="ma-0">
    <v-col cols="12" class="py-5 px-6">
      <v-text-field
        :placeholder="placeholderMsg"
        single-line
        outlined
        hide-details
        :append-icon="'mdi-magnify'"
        :clear-icon="'mdi-close-circle'"
        clearable
        v-model="textVal"
        @change="doSearch"
        @click:clear="doClear"
        @click:append="doSearch"
        class="input-search"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
/* 검색 컴포넌트 */
export default {
  props: {
    placeholderMsg: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    textVal: null,
    keybordUp: false,
  }),
  watch: {
    textVal() {},
  },
  methods: {
    doSearch() {
      if (this.textVal != null && this.textVal.length > 0) {
        // 공통 스피너 ON
        this.$store.commit('SPINNER/ON_COMMON_SPINNER');

        this.$emit('setSearchParam', this.textVal);
      } else {
        this.doClear();
      }
    },
    doClear() {
      this.$emit('initSearchParam');
    },

    /* 모바일 키보드 올라오면 BottomNav 비활성화 */
    handleResize() {
      this.$store.commit('SET_BOTTOM_NAV_FLAG', this.keybordUp);
      this.keybordUp = !this.keybordUp;
    },
  },
  created() {
    this.keybordUp = false;
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style></style>
